import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { getUserToken } from './Common'

const PublicRoute = () => {
    const isLoggedIn = getUserToken()

    if (isLoggedIn) {
        return <Navigate to="/dashboard" replace />
    }

    return <Outlet />
}

export default PublicRoute